import { render, staticRenderFns } from "./StudentRegistration.vue?vue&type=template&id=422ff6a9&"
import script from "./StudentRegistration.vue?vue&type=script&lang=ts&"
export * from "./StudentRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./StudentRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports